module.exports = __webpack_public_path__ + "static/media/6.af4089a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/6.png
// module id = 1726
// module chunks = 0